<template>
	<div>
		<!-- 编辑界面 -->
		<el-drawer :title="title" :visible.sync="editFormVisible" @click="closeDialog" :size="600" class="margin_top_40"
			:wrapperClosable="false" :modal='false' :destroy-on-close='true'>
			<el-form label-width="8.75rem" :model="editForm" :rules="rules" ref="editForm" class="demo-form-inline"
				inline>
				<el-form-item label="公告标题" prop="title">
					<el-input class="input_200px" size="small" v-model="editForm.title" auto-complete="off"
						placeholder="请输入公告标题"></el-input>
				</el-form-item>
				<el-form-item label="显示顺序" prop="seq">
					<el-input class="input_200px" size="small" v-model.number="editForm.seq" auto-complete="off"
						placeholder="请输入显示顺序"></el-input>
				</el-form-item>
				<el-form-item label="是否显示" prop="isShow">
					<el-switch v-model="editForm.isShow" active-color="#13ce66" inactive-color="#d8d8d8">
					</el-switch>
				</el-form-item></br>
				<el-form-item label="是否置顶" prop="isTop">
					<el-switch v-model="editForm.isTop" active-color="#13ce66" inactive-color="#d8d8d8">
					</el-switch>
				</el-form-item>
				<el-form-item label="开始时间" prop="startTime">
					<el-date-picker size="small" class="input_200px" value-format="yyyy-MM-dd HH:mm:ss"
						v-model="editForm.startTime" type="datetime" placeholder="请选择开始时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="结束时间" prop="endTime">
					<el-date-picker size="small" class="input_200px" value-format="yyyy-MM-dd HH:mm:ss"
						v-model="editForm.endTime" type="datetime" placeholder="请选择结束时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="公告内容" prop="content">
					<el-input size="small" type="textarea" v-model="editForm.content" auto-complete="off"
						class="input_200px" :autosize="{ minRows: 4, maxRows: 16 }" placeholder="请输入公告内容">
					</el-input>
				</el-form-item>
				<el-form-item label="公告附件">
					<ImageListUpload v-if="showFile" v-model="fileList" :fileLimit="5" acceptParm=".png,.jpg,.jpeg,.doc,.docx" class="input_200px" @input="handleInput" />
				</el-form-item>
				<!-- 	<el-form-item label="附件查看" v-if="editForm.filePath">
					<el-image class="d_one_02" :src="imagePath" :preview-src-list="srcList">
					</el-image>
				</el-form-item> -->
			</el-form>
			<div class="drawer-footer">
				<el-button size="small" icon="el-icon-check" :loading="saveloading" class="title" @click="submitForm('editForm')">
					保存
				</el-button>
				<el-button :disabled="editForm.keyId === ''" size="small" type="danger" icon="el-icon-delete"
					:loading="saveloading" class="title" @click="deleteMenu">
					删除
				</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
	import ImageListUpload from "@/components/ImageListUpload.vue";
	import {
		GetSystemNoticeDetail,
		SaveSystemNotice,
		DeleteSystemNotice
	} from '../../../api/systemApi.js'
	export default {
		props: [],
		data() {
			return {
				saveloading: false,
				title: '',
				editFormVisible: false, //控制编辑页面显示与隐藏
				editForm: {
					keyId: "",
					title: "",
					content: '',
					seq: 0,
					isShow: true,
					isTop: true,
					startTime: "",
					endTime: "",
					filePath: ''
				},
				// rules表单验证
				rules: {
					title: [{
						required: true,
						message: '请输入公告标题',
						trigger: 'blur'
					}],
					// content: [{
					// 	required: true,
					// 	message: '请输入内容',
					// 	trigger: 'blur'
					// }],
				},

				fileList: [],
				showFile: false

			};
		},
		computed: {},
		watch: {},
		components: {
			ImageListUpload
		},
		created() {},
		mounted() {},
		methods: {
			handleInput(file) {
				if (file.length > 0) {
					this.editForm.filePath = JSON.stringify(file);
				} else {
					this.editForm.filePath = "";
				}
			},

			// 关闭编辑、增加弹出框
			closeDialog() {
				this.$refs['editForm'].resetFields()
				this.editFormVisible = false
			},

			//显示编辑界面
			editShow(row, type) {
				this.showFile = false;
				if (row != undefined && row != 'undefined') {
					this.fileList = [];
					this.title = '编辑'
					this.getDetail(row.keyId);
				} else {
					this.title = '新增'
					this.fileList = [];
					this.showFile = true;
					this.$data.editForm = this.$options.data.call(this).editForm
				}
				this.editFormVisible = true
			},

			// 获取详情
			getDetail(key) {
				let param = {
					keyId: key
				}
				GetSystemNoticeDetail(param)
					.then(res => {
						if (res.code === 1) {
							if (res.data.filePath === "" || res.data.filePath === null) {} else {
								this.fileList = JSON.parse(res.data.filePath)
							}
							this.$nextTick(() => {
								this.showFile = true;
							})
							
							this.editForm = res.data;
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.$message.error('数据加载失败，请稍后再试！')
					})
			},

			// 编辑、增加页面保存方法
			submitForm(editData) {
				this.$refs[editData].validate(valid => {
					if (valid) {
						SaveSystemNotice(this.editForm)
							.then(res => {
								this.loading = false
								if (res.code === 1) {
									this.editFormVisible = false
									this.$parent.getListData()
									this.$message({
										type: 'success',
										message: '保存成功！'
									})
								} else {
									this.$message({
										type: 'error',
										message: res.msg
									})
								}
							})
							.catch(err => {
								this.loading = false
								this.$message.error('保存失败，请稍后再试！')
							})
					} else {
						return false
					}
				})
			},

			// 删除
			deleteMenu() {
				this.$confirm('确定要删除<' + this.editForm.title + '>吗?', '信息', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					let parmter = {
						keyIds: [this.editForm.keyId],
					};
					DeleteSystemNotice(parmter)
						.then((res) => {
							if ((res.code === 1)) {
								this.$message({
									type: 'success',
									message: '已删除!',
								});
								this.editFormVisible = false
								this.$parent.getListData()
							} else {
								this.$message({
									type: 'info',
									message: res.msg,
								});
							}
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error('删除失败，请稍后再试！');
						});
				});
			},

		},
	}
</script>
<style scoped>

	/deep/ .el-switch__core {
		width: 40px !important;
	}

	.d_one_02 {
		width: 100px;
		height: 100px
	}
</style>